import { useEffect, useState } from "react";
import { useIsProductLoading } from "stores/product";

export const useIsLoadingEffect = () => {
  const isProductLoading = useIsProductLoading();
  const [isLoading, setIsLoading] = useState(isProductLoading);

  useEffect(() => {
    if (!isProductLoading && isLoading) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsLoading(false);
    }
  }, [isLoading, isProductLoading]);

  return [isLoading, setIsLoading] as const;
};
